/**
 * @file - this file is used to fetch the Organization data
 */

import { cacheDecorator, requirejsOne } from '@ds/swymkit/tools'
import type { ENXORGMAppUILoader_AMD } from '@ds/swymkit/typings'

import { getPlatformId } from '~/features-shared/config-manager/stores/swym-config'

/**
 * @description this function is used to check whether the organization structure is available or not
 *
 * @returns organization module or error if the service is not available in the platform
 */

async function _isOrganizationAvailable() {
  const ENXORGMAppUILoader = await requirejsOne<ENXORGMAppUILoader_AMD>
  ('DS/ENXORGMLoaderComponent/core/ENXORGMAppUILoader')
  return await ENXORGMAppUILoader.isOrgmEnabled({ platformId: getPlatformId() })
}

export async function isOrganizationAvailable() {
  return cacheDecorator('organization', _isOrganizationAvailable, 24 * 60 * 60 * 1000)
}
